export enum ParentRoutingAccess {
  RouteToNoStudents = 'RouteToNoStudents',
  RouteToNoClassroomForStudent = 'RouteToNoClassroomForStudent',
  RouteToStudentClassroom = 'RouteToStudentClassroom',
  ClassroomLicensesNotAssigned = 'ClassroomLicensesNotAssigned',
}
